import styled from 'styled-components';

export const StyledReviewsContainerInner = styled.div`
  padding: 32px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
